import(/* webpackMode: "eager" */ "/workspace/apps/web/src/core/styles/global.css");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/authentication/hooks/use-authorization.ts");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/entities/authentication/model/authorization.context.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ExperimentTracker"] */ "/workspace/apps/web/src/entities/feature-flag/ui/experiment-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JpTrialHomeRedirectGate"] */ "/workspace/apps/web/src/features/jp-trial-application/home-redirect-gate.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["JpTrialApplicationView"] */ "/workspace/apps/web/src/features/jp-trial-application/view.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppOpenButton"] */ "/workspace/apps/web/src/features/native/ui/app-open-button.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/shared/config/i18n/client.ts");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/shared/config/i18n/provider.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/apps/web/src/shared/config/i18n/user-locale-bootstrap.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WebVitals"] */ "/workspace/apps/web/src/shared/ui/web-vitals/web-vitals.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HydrationBoundary"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/HydrationBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["IsRestoringProvider","useIsRestoring"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/IsRestoringProvider.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/QueryClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["QueryErrorResetBoundary","useQueryErrorResetBoundary"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js");
;
import(/* webpackMode: "eager", webpackExports: ["useInfiniteQuery"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsFetching"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useIsFetching.js");
;
import(/* webpackMode: "eager", webpackExports: ["useMutation"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useMutation.js");
;
import(/* webpackMode: "eager", webpackExports: ["useIsMutating","useMutationState"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useMutationState.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQueries"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useQuery"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseInfiniteQuery"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useSuspenseInfiniteQuery.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQueries"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useSuspenseQueries.js");
;
import(/* webpackMode: "eager", webpackExports: ["useSuspenseQuery"] */ "/workspace/node_modules/.pnpm/@tanstack+react-query@5.89.0_react@19.1.7/node_modules/@tanstack/react-query/build/modern/useSuspenseQuery.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.5.28_@babel+core@7.29.7_supports-color@8.1.1__@opentelemetry+api@1.9.1_@playwri_73ab67d97fa4fbe752b27c5cdbe50af3/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/.pnpm/next@15.5.28_@babel+core@7.29.7_supports-color@8.1.1__@opentelemetry+api@1.9.1_@playwri_73ab67d97fa4fbe752b27c5cdbe50af3/node_modules/next/font/local/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"\",\"arguments\":[{\"src\":\"../../public/fonts/PretendardVariable.woff2\",\"weight\":\"45 920\",\"style\":\"normal\",\"display\":\"swap\",\"variable\":\"--font-pretendard\"}],\"variableName\":\"Pretendard\"}");
;
import(/* webpackMode: "eager", webpackExports: ["NuqsAdapter"] */ "/workspace/node_modules/.pnpm/nuqs@2.8.6_next@15.5.28_@babel+core@7.29.7_supports-color@8.1.1__@opentelemetry+api@1.9_74618e3c8c9f9c27b2a5fb8093b71da2/node_modules/nuqs/dist/adapters/next/app.js");
;
import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/workspace/packages/analytics/src/next/analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/AiPodoIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/AnimPodoPrestudyDialogIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/BottomNavigationAiLearningIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/BottomNavigationHomeIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/BottomNavigationLessonIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/BottomNavigationMypodoIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/BottomNavigationReservationIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/BottomNavigationTutorIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/BusinessMainIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/CheerupIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/EmptyLessonIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/LevelUpIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/LoadingIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/LowSegmentIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/MiddleSegmentIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/NotificationIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/PartyPodoIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/RelaxingPodoIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/SuccessIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/SurfingPodoIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/TicketEnjaIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/TopSegmentIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/WalkingIconLottie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/assets/src/components/WrongIconLottie.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/alert-dialog/alert-dialog-v1.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/alert-dialog/alert-dialog.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/bottom-sheet/bottom-sheet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/design-system-temp/src/components/button/button-v1.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/button/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/design-system-temp/src/components/checkbox/checkbox-v1.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/checkbox/checkbox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/design-system-temp/src/components/chip/chip-v3.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/design-system-temp/src/components/chip/chip-with-badge-v3.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/design-system-temp/src/components/chip/chip-with-badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/design-system-temp/src/components/chip/chip.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/confirm-dialog/confirm-dialog-v1.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/confirm-dialog/confirm-dialog.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/feedback-list/feedback-list.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/popover/popover.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/progress/progress.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/packages/design-system-temp/src/components/radio/radio.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/separator/separator.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/stepper/stepper.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/tabs/tabs-v1.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/tabs/tabs.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/toaster/toaster.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/components/toggle/switch.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/styles/global.css");
;
import(/* webpackMode: "eager" */ "/workspace/packages/design-system-temp/src/styles/podo-variables.css");
;
import(/* webpackMode: "eager", webpackExports: ["FlagProvider","useFlagContext"] */ "/workspace/packages/flags/src/react/flag-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useFlag"] */ "/workspace/packages/flags/src/react/use-flag.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useFlagsCompat"] */ "/workspace/packages/flags/src/react/use-flags.ts");
